import { doFetch, doPostFetch } from "./apiFetchHelper";
const url = `/api/preferences`;

export const getPreferences = () => {
  return doFetch(url);
};

export const postPreferences = (params) => {
  return doPostFetch(url, params);
};
